import React from 'react';
import { googleAuth } from '../services/CondamindAPI';

const Capsule = ({ handleSendButton, suggestion, index, shouldCloseMenu, closeMenu }) => {
    const runCapsule = async (suggestion) => {
        if (!suggestion.action) {
            handleSendButton(suggestion.title);
            return;
        }

        switch (suggestion.action) {
            case 'PREDEFINED_RESPONSE':
                const response = {
                    response: {
                        role: 'assistant',
                        content: suggestion.predefinedResponse,
                        suggestions: suggestion.suggestions,
                    },
                };
                handleSendButton(suggestion.title, response);
                break;
            case 'PREDEFINED_PROMPT':
                handleSendButton(suggestion.predefinedPrompt || suggestion.title);
                break;
            case 'DOWNLOAD_FILE':
                handleDownloadCV(suggestion.filePath);
                break;
            case 'CALL_FUNCTION':
                if (suggestion.functionName === 'GOOGLE_AUTH') {
                    await googleAuth();
                }
                break;
            case 'OPEN_LINK':
                if (suggestion.content) {
                    window.open(suggestion.content, '_blank');
                }
                break;
            default:
                handleSendButton(suggestion.title);
                break;
        }

        if (shouldCloseMenu) {
            closeMenu();
        }
    };

    const handleDownloadCV = (filePath) => {
        const link = document.createElement('a');
        link.href = filePath;
        link.setAttribute('download', filePath.split('/').pop());
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    };

    return (
        <button
            key={index}
            className="suggestion-btn-menu"
            onClick={() => runCapsule(suggestion)}
        >
            {suggestion.title}
        </button>
    );
};

export default Capsule;
